// extracted by mini-css-extract-plugin
module.exports = {"message":"alert_message__Zh7pP","button":"alert_button__JDkV5"};